import VerificationWithC2C from './VerificationWithC2C';

export default VerificationWithC2C;
